import React from "react";
import { useApp, LANGS } from "@/context/AppContext";

export default function HubHeader() {
  const { lang, setLang } = useApp();
  return (
    <header className="rbl-topbar" data-testid="hub-header">
      <div className="rbl-topbar-inner">
        <div className="rbl-logos">
          <img className="rbl-logo" src="/logo_rbl.png" alt="RBL Training" />
          <img className="mpg-logo" src="/logo_mpg.png" alt="Millennium Print Group" />
        </div>
        <div className="rbl-langs" role="tablist" aria-label="Language">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}`}
              className={`rbl-lang-btn ${lang === l.code ? "active" : ""}`}
              onClick={() => setLang(l.code)}
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
